"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.runTimeThemeInjection = exports.getVendorByHostName = exports.HOST_ORIGIN_TO_VENDOR_REGEX_MAP = void 0;
var types_1 = require("./types");
var THEME_BY_VENDOR = (_a = {},
    _a[types_1.Vendor.MESSAGEMEDIA] = 'mm.css',
    _a[types_1.Vendor.MULTITXT] = 'vodanz.css',
    _a[types_1.Vendor.DIRECTSMS] = 'directSMS.css',
    _a[types_1.Vendor.STREETDATA] = 'streetdata.css',
    _a[types_1.Vendor.WHOLESALESMS] = 'wholesale.css',
    _a[types_1.Vendor.TWO_DEGREES] = '2degrees.css',
    _a[types_1.Vendor.SMSB] = 'smsb.css',
    _a[types_1.Vendor.MESSAGENET] = 'messagenet.css',
    _a[types_1.Vendor.MOBIPOST] = 'mobipost.css',
    _a[types_1.Vendor.SMSCENTRAL] = 'smscentral.css',
    _a[types_1.Vendor.BULLETIN] = 'bulletin.css',
    _a[types_1.Vendor.ETXT] = 'etxt.css',
    _a[types_1.Vendor.TPGTELECOM] = 'tpg.css',
    _a[types_1.Vendor.SIMPLE_TEXTING] = 'simpletexting.css',
    _a[types_1.Vendor.MESSAGE_STUDIO] = 'messagestudio.css',
    _a[types_1.Vendor.SINCH_EU] = 'sincheu.css',
    _a[types_1.Vendor.NOTIFY_NOW] = 'notify-now.css',
    _a);
exports.HOST_ORIGIN_TO_VENDOR_REGEX_MAP = [
    /**
     * Production
     */
    // MM
    { regex: /^(http(s)?:\/\/)?hub\.messagemedia\.com/, vendor: types_1.Vendor.MESSAGEMEDIA },
    // SMSCentral hosts end with smscentral.com.au
    { regex: /^(http(s)?:\/\/)?(preview|my)\.smscentral\.com\.au/, vendor: types_1.Vendor.SMSCENTRAL },
    // Bulletin host end with bulletinmessenger.net
    { regex: /^(http(s)?:\/\/)?(preview|www)\.bulletinmessenger\.net/, vendor: types_1.Vendor.BULLETIN },
    // WholesaleSMS hosts end with wholesalesms.com.au
    { regex: /^(http(s)?:\/\/)?(preview|app)\.wholesalesms\.com\.au/, vendor: types_1.Vendor.WHOLESALESMS },
    // multitxt urls start with multitxt followed by a dot or dash
    { regex: /^(http(s)?:\/\/)?multitxt[.-]/, vendor: types_1.Vendor.MULTITXT },
    // the new multitxt hosts end with multitxt.one.nz
    { regex: /^(http(s)?:\/\/)?app\.multitxt\.one\.nz/, vendor: types_1.Vendor.MULTITXT },
    // directsms production app url
    { regex: /^(https:\/\/)?(preview|my)\.directsms\.com\.au/, vendor: types_1.Vendor.DIRECTSMS },
    // Streetdata hosts end with streetdata.com.au
    { regex: /^(http(s)?:\/\/)?(preview|app)\.streetdata\.com\.au/, vendor: types_1.Vendor.STREETDATA },
    // 2degrees Production URL
    { regex: /^(http(s)?:\/\/)?app\.grouptext\.2degrees\.nz/, vendor: types_1.Vendor.TWO_DEGREES },
    // MessageNet hosts end with messagenet.com.au
    { regex: /^(http(s)?:\/\/)?app\.messagenet\.com\.au$/, vendor: types_1.Vendor.MESSAGENET },
    // SMSBroadcast hosts end with smsbroadcast.com.au
    { regex: /^(http(s)?:\/\/)?(preview|app)\.smsbroadcast\.com\.au/, vendor: types_1.Vendor.SMSB },
    // Mobipost hosts end with mobipost.com.au
    { regex: /^(http(s)?:\/\/)?(preview|app)\.mobipost\.com\.au/, vendor: types_1.Vendor.MOBIPOST },
    // eTXT urls start with etxt followed by a dot or dash
    { regex: /^(http(s)?:\/\/)?(.+\.)?etxt(\.|-|service)/, vendor: types_1.Vendor.ETXT },
    // TPGTelecom
    { regex: /^(http(s)?:\/\/)?(.+\.)?tpg/, vendor: types_1.Vendor.TPGTELECOM },
    // SimpleTexting
    { regex: /^(http(s)?:\/\/)?(.+\.)?simpletexting/, vendor: types_1.Vendor.SIMPLE_TEXTING },
    // MessageStudio (grey-label of MessageMedia)
    { regex: /^(http(s)?:\/\/)?(messagestudio)(-)?.(.*)/, vendor: types_1.Vendor.MESSAGE_STUDIO },
    // Sinch EU
    { regex: /^(http(s)?:\/\/)?(eu.app.sinch.com)/, vendor: types_1.Vendor.SINCH_EU },
    /**
     * Non Production
     */
    // directsms urls start with directsms followed by a dot or dash
    { regex: /^(http(s)?:\/\/)?directsms[.-]/, vendor: types_1.Vendor.DIRECTSMS },
    // WholesaleSMS urls start with wholesalesms followed by a dot or dash
    { regex: /^(http(s)?:\/\/)?wholesalesms[.-]/, vendor: types_1.Vendor.WHOLESALESMS },
    // Streetdata urls start with streetdata followed by a dot or dash
    { regex: /^(http(s)?:\/\/)?streetdata[.-]/, vendor: types_1.Vendor.STREETDATA },
    // Mobipost urls start with mobipost followed by a dot or dash
    { regex: /^(http(s)?:\/\/)?mobipost[.-]/, vendor: types_1.Vendor.MOBIPOST },
    // SMSBroadcast urls start with smsbroadcast followed by a dot or dash
    { regex: /^(http(s)?:\/\/)?smsbroadcast[.-]/, vendor: types_1.Vendor.SMSB },
    // MessageNet urls start with messagenet followed by a dot or dash
    { regex: /^(http(s)?:\/\/)?messagenet[.-]/, vendor: types_1.Vendor.MESSAGENET },
    // NetSMS is also a domain of MessageNet vendor
    { regex: /^(http(s)?:\/\/)?(preview\.|www\.|)netsms[.-]/, vendor: types_1.Vendor.MESSAGENET },
    // SMSCentral urls start with smscentral followed by a dot or dash
    { regex: /^(http(s)?:\/\/)?smscentral[.-]/, vendor: types_1.Vendor.SMSCENTRAL },
    // 2degrees urls start with 2degrees followed by a dot or dash
    { regex: /^(http(s)?:\/\/)?2degrees[.-]/, vendor: types_1.Vendor.TWO_DEGREES },
    // message media urls start with hub
    { regex: /^(http(s)?:\/\/)?hub\./, vendor: types_1.Vendor.MESSAGEMEDIA },
    // message media urls start with beta
    { regex: /^(http(s)?:\/\/)?beta\.(dev\.|qa\.|stg\.|)messagemedia\.com$/, vendor: types_1.Vendor.MESSAGEMEDIA },
    // legacy message media urls start with my
    { regex: /^(http(s)?:\/\/)?my\.(dev\.|qa\.|stg\.|)messagemedia\.com$/, vendor: types_1.Vendor.MESSAGEMEDIA },
    // message media feature branch urls start with mmgp-frontend
    { regex: /^(http(s)?:\/\/)?(messagemedia-)?mmgp-frontend[.-]/, vendor: types_1.Vendor.MESSAGEMEDIA },
    // Bulletin urls start with bulletin followed by a dot or dash
    { regex: /^(http(s)?:\/\/)?bulletin[.-]/, vendor: types_1.Vendor.BULLETIN },
    // QA multitxt urls start with web-multitxt followed by a dot or dash
    { regex: /^(http(s)?:\/\/)?web-multitxt[.-]/, vendor: types_1.Vendor.MULTITXT },
    // Alternative feature branch using vendor name for multitxt
    { regex: /^(http(s)?:\/\/)?vodanz[.-]/, vendor: types_1.Vendor.MULTITXT },
    // Sinch EU
    { regex: /^(http(s)?:\/\/)?(sincheu)(-)?.(.*)/, vendor: types_1.Vendor.SINCH_EU },
];
var getVendorByHostName = function (origin) {
    var vendor = types_1.Vendor.MESSAGEMEDIA;
    for (var i = 0; i < exports.HOST_ORIGIN_TO_VENDOR_REGEX_MAP.length; i += 1) {
        var matcher = exports.HOST_ORIGIN_TO_VENDOR_REGEX_MAP[i].regex;
        if (matcher.test(origin)) {
            vendor = exports.HOST_ORIGIN_TO_VENDOR_REGEX_MAP[i].vendor;
            break;
        }
    }
    return vendor;
};
exports.getVendorByHostName = getVendorByHostName;
var runTimeThemeInjection = function (_a) {
    var staticPath = _a.staticPath;
    try {
        var linkElements = document.getElementsByTagName('link');
        for (var i = 0; i < linkElements.length; i++) {
            var linkElement = linkElements[i];
            var href = linkElement.getAttribute('href');
            var rel = linkElement.getAttribute('rel');
            /**
             * This approach fulfills the Hub container requirement, which uses Antd, hence the following logic.
             * Consider modifying this function when targeting more audiences.
             */
            if (href && href.includes('antd') && rel && rel === 'stylesheet') {
                var vendor = (0, exports.getVendorByHostName)(window.location.origin);
                var themeElement = document.createElement('link');
                themeElement.setAttribute('rel', 'stylesheet');
                themeElement.setAttribute('href', "".concat(staticPath, "/").concat(THEME_BY_VENDOR[vendor]));
                themeElement.setAttribute('id', 'theme-plugin');
                linkElement.insertAdjacentElement('afterend', themeElement);
                break;
            }
        }
    }
    catch (e) {
        console.error('Error injecting theme', e);
    }
};
exports.runTimeThemeInjection = runTimeThemeInjection;
//# sourceMappingURL=runtime-theme-injection.js.map